module.exports = __webpack_public_path__ + "images/forza-horizon-4-b_rgba(0,0,0,0.7).56fed6bea7ccab9fe894672fdb70177d.jpg";